import { isFunction } from "lodash";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useLoanFilesHook } from "../../hooks/useLoanFilesHook";
import { loanDrilldownSet } from "../../redux/actions/loanDrilldownActions";
import FileUploadProcess from "./FileUploadProcess";

const LoanSubjectPropertyFileUploadProcess = ({
  loanId,
  propertyId,
  docType,
  docGroup,
  showDivider = true,
  keyName,
  onProcessComplete,
  perFileDocType = false,
}) => {
  const { uploadLoanDocsWithAssociations } = useLoanFilesHook();
  const dispatch = useDispatch();

  const [isProcessing, setIsProcessing] = useState(false);

  const handleOnSubmit = useCallback(
    (f, { onSuccessFn } = {}) => {
      if (!loanId) return;

      setIsProcessing(true);

      uploadLoanDocsWithAssociations({
        loanId,
        files: f,
        subjectPropertyIds: propertyId ? [propertyId] : undefined,
        onSuccessFn: (d) => {
          dispatch(loanDrilldownSet(d));
          setIsProcessing(false);
          onSuccessFn?.();
          if (isFunction(onProcessComplete)) onProcessComplete();
        },
        onFailFn: () => {
          setIsProcessing(false);
        },
      });
    },
    [
      loanId,
      propertyId,
      uploadLoanDocsWithAssociations,
      dispatch,
      onProcessComplete,
    ],
  );

  return (
    <FileUploadProcess
      loanId={loanId}
      docType={docType}
      borderSize={2}
      docGroup={docGroup}
      keyName={keyName}
      onSubmit={handleOnSubmit}
      loading={isProcessing}
      allowedDocGroups={PROPERTY_DOC_GROUPS}
      showDivider={showDivider}
      perFileDocType={perFileDocType}
    />
  );
};
const PROPERTY_DOC_GROUPS = [
  "Appraisal",
  "Construction Documents",
  "Insurance Docs",
  "Leases & Rents",
  "Property Documents",
  "Title Docs",
];
export default LoanSubjectPropertyFileUploadProcess;
